import { orange, red } from "@mui/material/colors";
import { DutyItem, DutyItemAttr, DutyLimit, DutyRow, Maybe, PilotDuty } from "../Generated/avroGraphqlDuty";
import dayjs from "dayjs";

export default {};

export function IsNullOrEmpty(target: string | null | Maybe<string> | undefined): boolean {
    return target === "" || target == null;
}

export function HasValue(target: string | Maybe<string> | Maybe<number> | Maybe<boolean> | null | undefined): boolean {
    return target !== "" && target !== null && target !== undefined;
}

export function DefinitelyAnArray<T>(nullableArray: Maybe<Array<Maybe<T>>> | undefined): Array<T> {
    if (!nullableArray || !Array.isArray(nullableArray)) return [] as T[];
    return nullableArray as T[];
}

export function IsValidNumber(possibleNumber: Maybe<number> | string | undefined, precision: number, allowNegatives = false): boolean {
    let result = true;

    try {
        if (isNaN(Number(possibleNumber))) result = false;
        const discard = new Number(possibleNumber ?? 0).valueOf();

        if (!allowNegatives) {
            if (discard < 0) {
                result = false;
            }
        }

        const numberParts = (possibleNumber?.toLocaleString() ?? "").split(".");
        const decimalPlaces = numberParts.length > 1 ? numberParts[1].length : 0;
        if (decimalPlaces > precision) {
            result = false;
        }

        if (numberParts.length > 1 && precision === 0) {
            result = false;
        }
    } catch {
        if (!(possibleNumber === "" || possibleNumber === ".")) {
            result = false;
        }
    } finally {
        // fricking eslint
    }

    return result;
}

export function NumberOrZeroIfInvalid(possibleNumber: Maybe<number> | string | undefined): number {
    let result: number = new Number(0).valueOf();
    try {
        result = new Number(possibleNumber ?? 0).valueOf();
        if (isNaN(result)) result = new Number(0).valueOf();
    } catch {
        result = new Number(0).valueOf();
    } finally {
        // fricking eslint
    }

    return result;
}

// accepts a date string like "2023-05-12" in YYYY-MM-DD format and returns if it is valid or not
export function isValidDate(date: string): boolean {
    const timestamp = Date.parse(date);
    return !isNaN(timestamp);
}

// accepts a date string like "2023-05-12" in YYYY-MM-DD format and returns if it is expired or not
export function isDateExpired(date: string): boolean {
    return dayjs(date).isBefore(dayjs());
}

export function prune(pilotDuty: PilotDuty): PilotDuty {
    let updatedPilotDuty = pilotDuty;
    // pruning unwanted attributes
    const dutyItems: Maybe<DutyItem>[] = updatedPilotDuty.DutyItems?.map((item) => {
        const newItem = item;
        const itemAttributes: Maybe<DutyItemAttr>[] = item?.ItemAttributes?.map((itemAttr) => {
            let itemAttrWithout__typename;
            if (itemAttr) {
                const { __typename, DutyAttrType, ...rest } = itemAttr;
                // remove PilotDuty.DutyItems.ItemAttributes.__typename, PilotDuty.DutyItems.ItemAttributes.DutyAttrType
                itemAttrWithout__typename = rest;
            }
            return itemAttrWithout__typename;
        }) as Maybe<DutyItemAttr>[];

        let itemWithout__typename;
        if (newItem) {
            const { id, AircraftType, __typename, ItemAttributes, ...rest } = newItem;
            // remove PilotDuty.DutyItems.AircraftType, PilotDuty.DutyItems.__typename (and PilotDuty.DutyItems.ItemAttributes(temporarily))
            itemWithout__typename = rest;
            // reassigning the pruned ItemAttributes
            Object.assign(itemWithout__typename, { ItemAttributes: itemAttributes });
        }
        return itemWithout__typename;
    }) as Maybe<DutyItem>[];

    const { DutyItems, __typename, ...rest } = updatedPilotDuty;
    // remove PilotDuty.DutyItems, PilotDuty.__typename
    updatedPilotDuty = rest;
    // reassigning the pruned DutyItems
    Object.assign(updatedPilotDuty, { DutyItems: dutyItems });
    return updatedPilotDuty as PilotDuty;
}

/*
    use the getTimezoneOffset() to offset local to UTC before it goes into DateTimePicker as value
    and offset UTC to local after it comes out of DateTimePicker through onChange */
const getTimezoneOffset = (value: Date) => value.getTimezoneOffset() * 60000;

export const makeLocalAppearUTC = (value: string | number | Date): string | Date => {
    const dateTime = new Date(value);
    const utcFromLocal = new Date(dateTime.getTime() + getTimezoneOffset(dateTime));

    return utcFromLocal;
};

export const localToUTC = (dateTime: Date | null): Date | null => {
    if (dateTime) {
        const utcFromLocal = new Date(new Date(dateTime).getTime() - getTimezoneOffset(new Date(dateTime)));
        return utcFromLocal;
    }
    return dateTime;
};

function getLimit(limitInPeriod: DutyLimit[]): DutyLimit | undefined {
    enum limitType {
        ALL = "all",
        FIXED = "fixed",
    }

    const limit = limitInPeriod.find((limitEle) => limitEle.type === limitType.ALL || limitEle.type === limitType.FIXED);

    return limit;
}

export function getBackgroundColorForLimit(duty_row: DutyRow): string {
    let backgroundColor = "white";

    if (duty_row && duty_row.limit_in_period && duty_row.value) {
        const limit = getLimit(duty_row?.limit_in_period as DutyLimit[]);

        if (limit && limit.limit) {
            const valuePercent = (duty_row?.value.value / limit.limit) * 100;

            if (duty_row?.value.value > limit?.limit) backgroundColor = red[700];
            else if (limit?.threshold_percent && valuePercent > limit?.threshold_percent) backgroundColor = orange[500];
        }
    }

    return backgroundColor;
}
